import { render, staticRenderFns } from "./ConsumptionInvoice.vue?vue&type=template&id=560ad623&scoped=true&"
import script from "./ConsumptionInvoice.vue?vue&type=script&lang=js&"
export * from "./ConsumptionInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ConsumptionInvoice.vue?vue&type=style&index=0&id=560ad623&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560ad623",
  null
  
)

export default component.exports